import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getUserSignOut } from "../services/api";
import { ToastContainer } from "react-toastify";
import * as roomRTC from "../services/roomRTC";

import Navbar from "../components/Navbar/Navbar";
import VideoCall from "../components/Room/VideoCall";
import UsersLoggeds from "../components/Home/UsersLoggeds";
import ChatPrivate from "../components/Chats/ChatPrivate/ChatPrivate";
import Scenario from "../components/Room/Scenario";
import ScenarioOverlay from "../components/Room/ScenarioOverlay";
import Participants from "../components/Room/Participants";
import TimerStamp from "../components/Room/TimerStamp";
import Stations from "../components/Room/Stations";
import ProgressNotes from "../components/Room/ProgressNotes";

import "../App.css";

const Room = ({ authToken, isRoomHost, roomId, usuarioId, identity, roomSocketId, isOnlyAudio, isOnlyCamera, isRoomListener }) => {

    useEffect(() => {
        const effectAsync = async () => {
            if (!authToken) {
                getUserSignOut({ roomSocketId });
            }

            if (!isRoomListener) {
                await roomRTC.getInitialRoomConnection(isRoomHost, identity, usuarioId, roomId, isOnlyAudio, isOnlyCamera, isRoomListener);
            }
        };

        effectAsync();
    }, []);

    useEffect(() => {
        roomRTC.sendVolumeIconStreamDataChannel(roomSocketId, isOnlyAudio);
    }, []);

    return (
        <div className="container-fluid">
            <Navbar />

            <div className="row home_container">
                <div className="col-md-3">
                    <VideoCall />
                    <UsersLoggeds />
                    <ChatPrivate />
                </div>

                <div className="col-md-6">
                    <Scenario />
                    <ScenarioOverlay />
                </div>

                <div className="col-md-3">
                    <Participants />
                    <TimerStamp />
                    <ProgressNotes />
                    <Stations />
                </div>
            </div>

            <ToastContainer
                theme="dark"
                autoClose={3000}
                closeButton={false}
                position="top-right"
            />
        </div>
    )
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(Room);